import { render, staticRenderFns } from "./ExternalPostList.vue?vue&type=template&id=0f8aedba&scoped=true"
import script from "./ExternalPostList.vue?vue&type=script&lang=js"
export * from "./ExternalPostList.vue?vue&type=script&lang=js"
import style0 from "./ExternalPostList.vue?vue&type=style&index=0&id=0f8aedba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8aedba",
  null
  
)

export default component.exports